import { Divider, IndexPath, Select, SelectItem } from "@ui-kitten/components";
import BaseCard from "components/BaseCard";
import Button from "components/Button";
import BuyFlowPaymentDetailCard from "components/BuyFlowPaymentDetailCard";
import PlanDescriptionComponent from "components/PlanDescriptionComponent";
import Spacer from "components/Spacer";
import { setStep } from "features/slices/buyFlowSlice";
import { PlanPackageDetails, SignupChargeDetails } from "features/types";
import { useAppDispatch } from "hooks/useAppDispatch";
import React from "react";
import { View } from "react-native";

interface UpgradePlanStepOneProps {
  title: string;
  planPackages: PlanPackageDetails[];
  setSelectedUpgradePlan: React.Dispatch<
    React.SetStateAction<PlanPackageDetails | null>
  >;
  selectedUpgradePlan: PlanPackageDetails | null;
  planChangeCharge: SignupChargeDetails | undefined;
}

const UpgradePlanStepOne: React.FC<UpgradePlanStepOneProps> = ({
  title,
  planPackages,
  setSelectedUpgradePlan,
  selectedUpgradePlan,
  planChangeCharge,
}) => {
  if (!selectedUpgradePlan) return null;

  const dispatch = useAppDispatch();
  const displayValue = selectedUpgradePlan.name;
  const selectedIndex = planPackages.findIndex(
    (plan) => plan.id === selectedUpgradePlan.id
  );
  return (
    <View>
      <BaseCard title={title}>
        <Divider style={{ marginVertical: 15 }} />
        <Select
          value={displayValue}
          selectedIndex={new IndexPath(selectedIndex)}
          onSelect={(index) => {
            setSelectedUpgradePlan(planPackages[(index as IndexPath).row]);
          }}
        >
          {planPackages.map((planPackage) => (
            <SelectItem key={planPackage.id} title={planPackage.name} />
          ))}
        </Select>
        <Spacer />

        <PlanDescriptionComponent
          description={selectedUpgradePlan.description}
        />
      </BaseCard>

      <Spacer />

      {planChangeCharge && (
        <BuyFlowPaymentDetailCard
          planPackage={selectedUpgradePlan}
          signupCharge={planChangeCharge}
        />
      )}
      <Spacer />

      <Button
        onPress={() => dispatch(setStep(2))}
        disabled={!planChangeCharge}
        testID="upgrade-plan-step-one-button"
      >
        Continue
      </Button>
    </View>
  );
};

export default UpgradePlanStepOne;
